module.exports = __webpack_public_path__ + "static/media/pepper.13fe3740.png";